import { useState } from "react";
import { AdoptionTaxCreditProps } from "./adoptionTaxCredit";
import { RichText } from "../richText";
import { FormPayload } from "./benefits";

export function TaxCalculator(props: AdoptionTaxCreditProps) {
  const moduleInfo = props.moduleInfo;

  const buttonClass =
    "rollover-animation mt-8 text-body-3-medium rounded-[80px] border-2 border-teal bg-white py-[12px] px-[40px] text-onyx";

  const [income, setIncome] = useState<number | undefined>();
  const [formName, setFormName] = useState<string | undefined>();
  const [formEmail, setFormEmail] = useState<string | undefined>();
  const [formResponse, setFormResponse] = useState<boolean>(false);

  const [qualifiedCredit, setQualifiedCredit] = useState<
    "min" | "max" | "between" | undefined
  >();

  const calculate = (value: number) => {
    const minIncome = 239230;
    const maxIncome = 279230;
    if (value <= minIncome) {
      setQualifiedCredit("min");
    } else if (value >= maxIncome) {
      setQualifiedCredit("max");
    } else {
      setQualifiedCredit("between");
    }
  };

  const formPayload: FormPayload[] = [
    {
      name: "email",
      value: formEmail ?? "",
    },
    {
      name: "firstname",
      value: formName?.split(" ")[0] ?? "",
    },
    {
      name: "lastname",
      value:
        formName
          ?.split(" ")
          .splice(1, formName.split(" ").length - 1)
          .join(" ") ?? "",
    },
  ];

  const sendDetails = async () => {
    const hubspotPortalId = "14522431";
    const hubspotFormId = "6416dfb8-44aa-4709-97da-db34f79c2b2b";
    const endpoint = `https://api.hsforms.com/submissions/v3/integration/submit/${hubspotPortalId}/${hubspotFormId}`;
    const payload = {
      fields: formPayload,
    };
    const requestOptions: RequestInit = {
      method: "POST",
    };
    requestOptions.body = JSON.stringify(payload);
    requestOptions.headers = { "Content-Type": "application/json" };
    await fetch(endpoint.toString(), requestOptions).then((response) => {
      if (response.ok) {
        setFormResponse(true);
      }
    });
  };

  const startAgain = () => {
    setQualifiedCredit(undefined);
    setFormResponse(false);
    setIncome(undefined);
    setFormEmail(undefined);
    setFormName(undefined);
  };

  return (
    <>
      {qualifiedCredit === undefined && (
        <>
          <p className="text-head-7 text-left">
            {props.moduleInfo.taxCredit?.annualIncomeLabel}
          </p>
          <form className="mt-8 flex flex-wrap justify-center md:justify-around">
            <div className="flex flex-col justify-end border-b-[1px] border-teal pb-2">
              <div>
                <span className="text-head-7 mr-2 text-teal">$</span>
                <input
                  style={{ backgroundColor: "transparent" }}
                  className="border-transparent text-body-2 w-[280px] italic  focus:outline-0"
                  type="number"
                  value={income}
                  onChange={(e) => setIncome(parseFloat(e.target.value))}
                  placeholder={
                    props.moduleInfo.taxCredit?.annualIncomePlaceholder
                  }
                />
              </div>
            </div>

            <button
              disabled={!income || income <= 0}
              className={buttonClass}
              onClick={() => calculate(income ?? 0)}
            >
              {props.moduleInfo.taxCredit?.textCalculateButton}
            </button>
          </form>
          <div className="mt-12">
            <p className="text-body-2-medium text-center text-gray">
              {props.moduleInfo.taxCredit?.qualifyText}
            </p>
            <p className="text-head-5 mt-2 text-center text-teal">
              $0 per adoption*
            </p>
          </div>
        </>
      )}

      {qualifiedCredit && qualifiedCredit !== "max" && (
        <div className="flex flex-col justify-between">
          <div className="mb-8 flex justify-center">
            <button
              className="text-body-4 flex gap-2 text-center text-gray"
              onClick={startAgain}
            >
              <span className="filter-teal">
                <img src="/arrow_return.svg" />
              </span>
              start again
            </button>
          </div>
          <div>
            {!formResponse && (
              <div>
                {qualifiedCredit === "min" && (
                  <div>
                    <p className="text-head-7">You qualify for:</p>
                    <p className="text-head-5 mt-2 text-teal">
                      $15,950 per adoption*
                    </p>
                  </div>
                )}

                <p className="text-body-3 mt-8 text-left">
                  <strong>
                    <span>{moduleInfo.taxCredit?.calcResults?.qualified}</span>
                  </strong>
                </p>
                <form className="mt-16">
                  <div className="flex flex-row justify-between gap-2  pb-2">
                    <div className="w-full border-b border-teal ">
                      <input
                        style={{ backgroundColor: "transparent" }}
                        className="border-transparent text-body-4 block w-full italic text-gray placeholder:text-gray focus:outline-0"
                        value={formName}
                        onChange={(e) => setFormName(e.target.value)}
                        placeholder="Your Name"
                      />
                    </div>
                    <div className="w-full border-b border-teal">
                      <input
                        style={{ backgroundColor: "transparent" }}
                        className="border-transparent text-body-4 block w-full italic text-gray placeholder:text-gray focus:outline-0"
                        value={formEmail}
                        onChange={(e) => setFormEmail(e.target.value)}
                        placeholder="Your e-mail"
                      />
                    </div>
                  </div>
                </form>

                <div className="mb-8 flex justify-center">
                  <button className={buttonClass} onClick={() => sendDetails()}>
                    {
                      moduleInfo.taxCredit?.calcResults?.sendInfo
                        ?.sendButtonText
                    }
                  </button>
                </div>

                <span className="text-gray">
                  <RichText
                    content={moduleInfo.taxCredit?.calcResults?.sendInfo?.legal}
                  />
                </span>
              </div>
            )}

            {formResponse && (
              <>
                <p className="text-head-6 text-center text-gray">
                  {
                    moduleInfo.taxCredit?.calcResults?.sendInfo
                      ?.sentInfoFeedbackHeading
                  }
                </p>
                <p className="text-body-3  mt-16 text-center text-gray">
                  <strong>
                    {
                      moduleInfo.taxCredit?.calcResults?.sendInfo
                        ?.sentInfoFeedbackSubHeading
                    }
                  </strong>
                </p>
              </>
            )}
          </div>
        </div>
      )}

      {qualifiedCredit === "max" && (
        <>
          <div className="mb-24 flex justify-center">
            <button
              className="text-body-4 flex gap-2 text-center text-gray"
              onClick={() => startAgain()}
            >
              <span className="filter-teal">
                <img src="/arrow_return.svg" />
              </span>
              start again
            </button>
          </div>

          <p className="text-head-7 text-center text-gray">
            {moduleInfo.taxCredit?.calcResults?.notQualifiedHeading}
          </p>
          <p className="text-body-3 mt-8 text-center text-gray">
            <strong>
              {moduleInfo.taxCredit?.calcResults?.notQualifiedSubHeading}
            </strong>
          </p>
        </>
      )}
    </>
  );
}
